import { inject, Injectable, Signal } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { WalletCard } from '@kr/models';

import { ExchangeComponent } from './exchange.component';

@Injectable()
export class ExchangeDialog {
  readonly #dialog = inject(DialogService);

  open(wallet: WalletCard, wallets: Signal<WalletCard[]>): DialogRef {
    return this.#dialog.open(ExchangeComponent, { wallet, wallets });
  }
}
